import { CloseCircleFilled } from '@ant-design/icons';
import { ResponsiveCard } from '@framework/ui/components/card/ResponsiveCard.tsx';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { StyledResult } from './StyledResult.tsx';

interface IVerifyPassNotFoundResultProps {
  onReset: () => void;
}

/**
 * Componente per visualizzare il risultato di tesserino non trovato
 */
export function VerifyPassNotFoundResult(
  props: IVerifyPassNotFoundResultProps,
) {
  const { t } = useTranslation();
  const { onReset } = props;
  return (
    <ResponsiveCard styles={{ body: { padding: 0 } }}>
      <StyledResult
        status="error"
        icon={<CloseCircleFilled aria-hidden="true" />}
        title={t(
          'verifica-tesserino.result.tesserino-non-trovato',
          'Tesserino non trovato!',
        )}
        subTitle={
          <Typography.Text>
            {t(
              'verifica-tesserino.result.tesserino-non-trovato.description',
              "Tesserino non trovato nell'elenco dei tesserini attivi.",
            )}
          </Typography.Text>
        }
        extra={
          <Button size="large" type="primary" onClick={onReset}>
            {t('verifica-tesserino.torna-alla-ricerca', 'Torna alla ricerca')}
          </Button>
        }
      />
    </ResponsiveCard>
  );
}
